'use client';

import { signInWithAppleForLinking } from '@repo/auth';
import { Button, toast } from '@repo/ui';
import { Apple, Loader2 } from 'lucide-react';
import * as React from 'react';

export function AppleLinkButton({ callbackURL }: { callbackURL: string }): React.ReactNode {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = (): void => {
    setIsLoading(true);
    signInWithAppleForLinking(callbackURL).catch(() => {
      toast.error('Failed to redirect to Apple');
      setIsLoading(false);
    });
  };

  return (
    <Button
      variant="outline"
      size="lg"
      className="w-full gap-2 bg-black text-white hover:bg-black/90 hover:text-white border-black"
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? <Loader2 className="size-4 animate-spin" /> : <Apple className="size-4" />}
      Sign in with Apple
    </Button>
  );
}
